<script setup>
  import Image from '@components/Image.vue'

  import { clampText } from '@shared/util.js'

  defineProps({
    agent: Object,
  })
</script>

<template>
  <div class="item">
    <a :href="agent.path">
      <div class="left">
        <div class="photo">
          <Image :image="agent.thumbnail" />
        </div>
      </div>
      <div class="right">
        <div class="info">
          <h4>{{ agent.name }}</h4>
          <p>{{ clampText(agent.description, 230) }}</p>
        </div>
        <div class="detail_controles">
          <div class="detail">
            <p>{{ agent.properties }}</p>
            <p>{{ agent.locations }}</p>
            <p>{{ agent.languages }}</p>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
